// extracted by mini-css-extract-plugin
module.exports = {"buffer":"_1aerhe9J","root":"_2Nv7GgQy","close-button":"_2sOhfGuw"};